import React from "react";
import styled from "styled-components";
import StyledAppBar from "../Header/StyledAppBar";

const PublicAgmRoute = ({ children }) => {
  return (
    <PublicAgmViewport>
      <StyledAppBar />

      {children}
    </PublicAgmViewport>
  );
};

export default PublicAgmRoute;

// const PublicAgmViewport = styled.div`
//   position: relative;

//   width: 100%;
//   height: 100vh;
//   height: 100dvh;

//   overflow: hidden;
// `;

const PublicAgmViewport = styled.div`
  position: relative;

  width: 100%;
  height: 100vh;
  height: 100dvh;

  overflow: hidden;

  @media (max-width: 900px) and (orientation: landscape) {
    height: 100dvh;
    overflow-x: hidden;
    overflow-y: auto;
  }
`;
